import { REDUCER_NAME } from './const'

const NS = REDUCER_NAME + '/'

export const TOGGLE_NAVIGATION = NS + 'TOGGLE_NAVIGATION'




// WEBPACK FOOTER //
// ./src/modules/layout/state/type.js